import { Directive, Input, TemplateRef, ViewContainerRef, OnDestroy } from "@angular/core";
import { FeatureFlagsService } from "../../services/feature-flags.service";
import { Subscription } from "rxjs";

/**
 * Structural directive that renders the template only when a feature flag is enabled.
 * Reacts to flag changes asynchronously so it works before the evaluate call returns.
 *
 * Usage:
 *   <app-ai-summary *featureFlag="'AI_SUMMARY'"></app-ai-summary>
 *
 *   <button *featureFlag="'NEW_TICKET_INBOX'">New Inbox</button>
 */
@Directive({
  selector: "[featureFlag]",
})
export class FeatureFlagDirective implements OnDestroy {
  private hasView = false;
  private sub: Subscription;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private featureFlagsService: FeatureFlagsService
  ) {}

  @Input() set featureFlag(code: string) {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    this.sub = this.featureFlagsService.isFeatureEnabled$(code).subscribe(
      (enabled) => {
        if (enabled && !this.hasView) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.hasView = true;
        } else if (!enabled && this.hasView) {
          this.viewContainer.clear();
          this.hasView = false;
        }
      }
    );
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
